/** Default number of pipes per row in the PipeSequence diagram. */
export const PIPE_SEQUENCE_PIPES_PER_ROW = 10;

/** Selectable “pipes per row” values for the sequence graph toolbar. */
export const PIPE_SEQUENCE_GRAPH_ROW_SIZE_OPTIONS = [5, 6, 7, 8, 9, 10] as const;

/** Upper bound for a single “full sequence” fetch used by the graph view. */
export const PIPE_SEQUENCE_MAX_FETCH = 1000;
